<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M13.5872 6.1635C12.623 7.00275 11.1063 6.85974 10.316 5.85506C9.52574 4.85038 9.74392 3.34271 10.7866 2.60331C11.7617 1.8323 14.857 2.28583 14.857 2.28583C14.857 2.28583 14.5736 5.3925 13.5872 6.1635Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.39923 8.08378C4.24363 8.81878 5.57187 8.69354 6.264 7.81367C6.95559 6.93449 6.75467 5.60606 5.85187 4.96585C4.99792 4.29064 2.28711 4.68783 2.28711 4.68783C2.28711 4.68783 2.53535 7.40857 3.39923 8.08378Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M0.572266 13.7144C0.572266 13.7144 2.85798 11.4287 8.00084 11.4287C13.1437 11.4287 15.4294 13.7144 15.4294 13.7144"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.4224 5.98438L10.2703 6.12637C9.12742 7.26923 8.11055 9.90188 8.0008 11.4289C8.0008 9.61976 7.65182 8.81683 6.37813 7.79447L6.32227 7.74136"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
